import { render, staticRenderFns } from "./OrganizationRegistration.vue?vue&type=template&id=d999fb42&scoped=true&"
import script from "./OrganizationRegistration.vue?vue&type=script&lang=ts&"
export * from "./OrganizationRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationRegistration.vue?vue&type=style&index=0&id=d999fb42&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d999fb42",
  null
  
)

export default component.exports